export default __webpack_public_path__ + "4a590a8d2061512303660f97ba059037.jpg";